'use client';
import { Col, Container, Placeholder, Row } from 'react-bootstrap';

export default function PrintableHeroSkeleton() {
  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col xs={12} md={8}>
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Row>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={8}>
          <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
          <Row>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
            <Col xs={12} sm={6}>
              <Placeholder xs={12} style={{ height: '220px' }} />
              <Placeholder xs={12} style={{ marginBottom: '20px' }} size="lg" />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
